import React from 'react';
import { formatCurrency } from '../lib/utils';
import { Checkbox } from '../components/ui/checkbox';
import { CheckCircle } from 'lucide-react';

export const UninvoicedBookingsTable = ({ bookings, selectedIds, onToggle, onToggleAll }) => {
  if (bookings.length === 0) {
    return (
      <div className="text-center py-8 text-[#94A3B8]">
        <CheckCircle className="w-10 h-10 mx-auto mb-2 opacity-40" />
        <p>No uninvoiced bookings for this client</p>
        <p className="text-xs mt-1">Only confirmed and production bookings appear here</p>
      </div>
    );
  }

  return (
    <div className="border border-[#1E293B] rounded-md overflow-hidden">
      <table className="w-full">
        <thead>
          <tr className="bg-[#0A0A0A]/80 border-b border-[#1E293B]">
            <th className="py-2 px-3 text-left">
              <Checkbox
                checked={selectedIds.length === bookings.length && bookings.length > 0}
                onCheckedChange={onToggleAll}
                data-testid="select-all-bookings"
              />
            </th>
            <th className="py-2 px-3 text-left text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Edition</th>
            <th className="py-2 px-3 text-left text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Product</th>
            <th className="py-2 px-3 text-right text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Rate</th>
            <th className="py-2 px-3 text-center text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Taxable</th>
            <th className="py-2 px-3 text-right text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Tax Rate</th>
            <th className="py-2 px-3 text-right text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Tax</th>
            <th className="py-2 px-3 text-right text-xs font-medium tracking-wide uppercase text-[#94A3B8]">Total</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#1E293B]">
          {bookings.map(bk => {
            const tax = bk.is_taxable ? (bk.rate || 0) * (bk.tax_rate || 0) / 100 : 0;
            return (
              <tr key={bk.id} className="hover:bg-[#1A1A1A]" data-testid={`uninvoiced-row-${bk.id}`}>
                <td className="py-2 px-3">
                  <Checkbox
                    checked={selectedIds.includes(bk.id)}
                    onCheckedChange={() => onToggle(bk.id)}
                  />
                </td>
                <td className="py-2 px-3 text-sm text-[#F8FAFC]">{bk.edition_name || 'N/A'}</td>
                <td className="py-2 px-3 text-sm text-[#F8FAFC]">{bk.product_type}</td>
                <td className="py-2 px-3 text-sm text-[#F8FAFC] text-right">{formatCurrency(bk.rate)}</td>
                <td className="py-2 px-3 text-sm text-center">
                  {bk.is_taxable
                    ? <span className="text-emerald-400 text-xs">Yes</span>
                    : <span className="text-[#475569] text-xs">No</span>}
                </td>
                <td className="py-2 px-3 text-sm text-[#94A3B8] text-right">{bk.is_taxable ? `${bk.tax_rate}%` : '-'}</td>
                <td className="py-2 px-3 text-sm text-[#94A3B8] text-right">{formatCurrency(tax)}</td>
                <td className="py-2 px-3 text-sm text-[#F8FAFC] text-right font-medium">{formatCurrency((bk.rate || 0) + tax)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
